/** The lines of a records series, in the order they draw. */
export const SERIES_NAMES = ["watched", "dropped", "incomplete"] as const;
export type SeriesName = (typeof SERIES_NAMES)[number];

/** One moment of a pipeline's records series: null where nobody was
 *  watching. What the chat's chart block assembles its lines from. */
export interface SeriesPoint {
  at: string;
  watched: number | null;
  dropped: number | null;
  incomplete: number | null;
}

/** The records series as the engine serves it (TTTL-257): counts at
 *  evenly spaced moments over (from, to], cumulative within a deployment,
 *  never differenced. Values sit parallel to `times`; null is a moment
 *  nobody was watching. */
export interface RecordsSeriesJson {
  pipeline: string;
  engine: string;
  generated_at: string;
  from: string;
  to: string;
  points_requested: number;
  runs: Array<{ watching_since: string; workers: number }>;
  times: string[];
  unit: string;
  series: Array<{ name: string; values: Array<number | null> }>;
}

/** One point per moment, the shape the chart draws: the `watched`,
 *  `dropped` and `incomplete` lines read side by side with `times`. A line
 *  the engine left out, or one shorter than the moments, is unknown where
 *  it is missing. */
export function seriesPoints(doc: RecordsSeriesJson): SeriesPoint[] {
  const line = (name: string) =>
    doc.series.find((s) => s.name === name)?.values ?? [];
  const watched = line("watched");
  const dropped = line("dropped");
  const incomplete = line("incomplete");
  return doc.times.map((at, i) => ({
    at,
    watched: watched[i] ?? null,
    dropped: dropped[i] ?? null,
    incomplete: incomplete[i] ?? null,
  }));
}
